import React from "react";
import { Spin } from "antd";
import StudentPageContainer from "@/components/layouts/StudentPageContainer";

const ExamLoadingView: React.FC = () => {
  return (
    <StudentPageContainer>
      <div className="h-screen flex items-start justify-center pt-40">
        <Spin size="large" tip="Loading..." />
      </div>
    </StudentPageContainer>
  );
};

export default ExamLoadingView;
